"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIConfigurationMailing = void 0;
const iconfiguration_mailing_feedback_1 = require("./iconfiguration-mailing-feedback");
const iconfiguration_mailing_upcoming_maintenance_1 = require("./iconfiguration-mailing-upcoming-maintenance");
function parseIConfigurationMailing(data) {
    if (data.feedback !== null && typeof data.feedback === 'object')
        data.feedback = (0, iconfiguration_mailing_feedback_1.parseIConfigurationMailingFeedback)(data.feedback);
    if (data.upcomingMaintenance !== null && typeof data.upcomingMaintenance === 'object')
        data.upcomingMaintenance = (0, iconfiguration_mailing_upcoming_maintenance_1.parseIConfigurationMailingUpcomingMaintenance)(data.upcomingMaintenance);
    return data;
}
exports.parseIConfigurationMailing = parseIConfigurationMailing;
